export const textComponents = (k) => {

    const aubrey = k.get("aubrey")[0];
    const mewo = k.get("mewo")[0];

    const gitHubText = mewo.add([
        k.text("GitHub", {
            size: 34,
            font: "pixelFonts",
            outline: { width: 4, color: k.rgb(255, 255, 255) }
        }),
        k.pos(46, 134),
        k.color(255, 255, 255),
        area(),
        "github"
    ])

    const projectsText = aubrey.add([
        k.text("Projects", {
            size: 6.1,
            font: "pixelFonts",
            outline: { width: 4, color: k.rgb(255, 255, 255) }
        }),
        k.pos(-12.8, 15),
        k.color(255, 255, 255),
        area(),
        "projects"
    ])

}